import { fechaApiToKey } from './fechas';

export const fechaObservanciaFeriadoDesdeKey = (fechaKey) => {
  const key = fechaApiToKey(fechaKey);
  if (!key) return null;
  const d = new Date(`${key}T12:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  if (d.getDay() === 0) {
    const lunes = new Date(d);
    lunes.setDate(lunes.getDate() + 1);
    const y = lunes.getFullYear();
    const m = String(lunes.getMonth() + 1).padStart(2, '0');
    const day = String(lunes.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }
  return key;
};

export const mapaFeriadosDesdeLista = (lista) => {
  const map = {};
  (lista || []).forEach((f) => {
    const key = fechaApiToKey(f.FechaObservancia);
    if (key) map[key] = f.Nombre;
  });
  return map;
};